<template>
  <div class="overflow-x-auto">
    <div
      v-if="[...parentOrders, ...childrenOrders].length"
      style="min-width: max-content">
      <tree :tree="parentOrders" reverse></tree>
      <div class="text-center main-chip">
        <span v-if="parentOrders.length" class="chip-line-top"></span>
        <v-chip append-icon="mdi-star" color="orange">
          <span class="text-truncate" style="max-width: 200px">
            {{ order.name }}
          </span>
        </v-chip>
        <span v-if="childrenOrders.length" class="chip-line-bottom"></span>
      </div>
      <tree :tree="childrenOrders"></tree>
    </div>
    <div v-else class="text-disabled text-center">
      Пов'язані накази відсутні
    </div>
  </div>
</template>

<script lang="ts">
import Tree from '@/components/tree/index.vue'
import { useRelatedOrders } from './relatedOrders'
import { useOrder } from '../order'
export default {
  name: 'RelatedOrders',
  components: { Tree },
  setup() {
    const { order } = useOrder()
    return { ...useRelatedOrders(), order }
  },
}
</script>

<style scoped lang="scss"></style>
